<template>
  <ion-page id="drill-page">
    <ion-content>
      <div id="the_board" :style="styleBoard">
        <CMChessboard :fen="fen" :validMoves="availableMoves"   
                  :orientation="orientation" 
                  :flagBadMove=true
                  :animateOnePly="animateFen" :hint="hintFen"
                  :arrows="arrowPairs"
                  :setSquareColor="squareColorArray"
                  :boardSize="boardSize" @board-move="boardMove" />
      </div>

      <div id="the_statusline" 
                  :style="styleStatusLine" 
                  :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
        {{ repertoireDescription }}
        <br>
        <span v-if="showThumb == 'done'">
          <ion-icon aria-hidden="true" :icon="thumbsUp" />
        </span>
        <span v-if="showThumb == 'alldone'">
          <ion-icon aria-hidden="true" :icon="star" />&nbsp;
          <ion-icon aria-hidden="true" :icon="star" />
        </span>
        {{ statusLineString }}
        <span v-if="showThumb == 'done'">
          <ion-icon aria-hidden="true" :icon="thumbsUp" />
        </span>
        <span v-if="showThumb == 'alldone'">
          <ion-icon aria-hidden="true" :icon="star" />&nbsp;
          <ion-icon aria-hidden="true" :icon="star" />
        </span>
      </div>

      <div id="the_movehistory" :style="styleMoveHistory" 
                      :class="{ 'text-dark' : isDark, 'text-light' : !isDark }">
        <MoveHistory :moveHistoryStack="moveHistoryStack" :trigger="moveHistoryTrigger" />
      </div>
    </ion-content>
    <Toolbar :elements="toolbarElements" :trigger="toolbarTrigger"        
                          @toolbar-click="toolbarClick"/>
  </ion-page>
</template>

<script setup >

  import { IonIcon,IonPage, IonContent, modalController } from '@ionic/vue';
  import { thumbsUp, star } from 'ionicons/icons';

  import Toolbar from '@/components/Toolbar.vue';

  import CMChessboard from '@/components/CMChessboard.vue'
  import party from "party-js";

  import { ref, watch } from 'vue'

  import ModalErrorMessage from '@/components/ModalErrorMessage.vue'

  // imports from web version

  import { buildPieceLocationStrings, getPieceSetName, columnToNumber, squarePairToAlgebraic,
    buildAvailableMoves } from '@/composables/blindfoldSupport.js'
  import MoveHistory from '@/components/MoveHistory.vue'
  
  import { Chess } from '@/ts/chess.ts'
  import { t } from '@/composables/translateText.js'

  import { useGetData } from '@/composables/getData.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { onMounted, onBeforeUnmount } from 'vue'

  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } 
              from '@/composables/screenSize'
  import { useWindowSizeStore } from '@/stores/windowSizeStore';

  import { findToolbarElement, setToolbarElementDisabledFlag, setToolbarElementLabel} 
                from '@/composables/toolbarSupport.js'

  const TOOLBAR_HINT = 0
  const TOOLBAR_NEXT_REP = 1
  
  const INITIAL_FEN = "rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"

  const MOVEHISTORY_FONTSIZE = 16
  const MOVEHISTORY_HEIGHT =  MOVEHISTORY_FONTSIZE * 1.2 + 4

  const connectionStore = useConnectionStore()

  var isSubscriber = (connectionStore.getIsSubscriber == 1)

  const isDark = ref(connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  const tourTrigger = ref(0)
  const showTour = ref(false)
  const showThumb = ref("none")

  const exploreColor = ref("white")
  const statusLineString = ref("")
  const repertoireDescription = ref("Loading Repertoire List...")

  const squareColorArray = ref([])

  var arrowPairs = ref([])

  var repertoires = []
  var repertoireIndex = 0

  const toolbarElements = ref([
    { index : TOOLBAR_HINT, label : t("Hint") , disabled : true, collapse:false},
    { index : TOOLBAR_NEXT_REP, label : t("Next-Rep") , disabled : true, collapse:false},
  ])

  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  const boardSize = ref(100)

  const fen = ref(INITIAL_FEN)
  const initialFenid4 = "147869767"
  const hintFen = ref([])
  const animateFen = ref([])

  var playingWhite = 1
  var repertoireId = "0"
 

  var blankAppendTrigger = " "
  var orientation = ref("white")
  const availableMoves = ref([])

  var moveList = new Map()
  var lineList = []

  // track where user is in the lines
  var lineIndex = -1
  var withinLineIndex = 0

  const moveHistoryStack = ref([])
  const moveHistoryTrigger = ref(0)
  const moveHistoryString = ref("")
  const toolbarTrigger = ref(0)

  var chess = new Chess()
  const todayDate = formatDate(new Date(),"")

  // tour stuff

  const sliceDiceTourInfo = {
    id : "opening_slicedice",
    elements : [
      { id: "", title: "Explore", text : "Why are we deciding our opening moves based on how the game ends 40 to 60 moves later?<br><br>That's an unfair burden for the game's first few moves."},
      { id: "", title: "There Is A Better Way!", text : "Chess Opening Mastery is a game changing, data driven approach to evaluating the game's first moves.<br><br>"},
      { id: "", title: "A Window into the Middle Game", text : "Chess Opening Mastery's revolutionary approach shows how the games are progressing in the middle game.<br><br>How? For every game, the Stockfish computer engine has been used to evaluate the position before white's moves 12, 15, 18 and 21. Stockfish scores each board as having an advantage for white (positive numbers) or an advantage for black (negative numbers)." },
      { id: "", title: "Stockfish Scores", text : "You probably know that a pawn is worth 1 point, a bishop/knight is worth 3 and a rook is 5 points. Stockfish reports back a position as being the equivalent of 'up' some number of pawns.<br><br>The bar chart shows that distribution for games start with the given move sequence."},
      { id: "", title: "The Game Collection", text : "The Lichess 'rapid' games were used to build the tree. With a unique twist - only games where the players are within the same 50 point 'bucket' are included.<br><br>Why? Because even a 50 point difference between two players gives the higher rated player a 6% win advantage which swamps any advantage that can be obtained by a particular opening."},
      { id: "the_tree", title: "The Graph", text : "The graph shows the distribution of the Stockfish engine scores for games where the checked move(s) was made.<br><br>For example, if '1.e4' is checked and the slider is at move 15 then the graph shows how well players who played 'e4' are doing in their games at move 15."},
      { id: "the_tree", title: "The Bars", text : "The bars show the percentage of games in each bucket. The buckets start on the left with black having already won the game by the future move number. Next to that is the percentage of games where black has a 'huge' advantage"},
      { id: "the_tree", title: "The Point Bars", text : "The next several bars break the stockfish engine scores into one point buckets.<br><br><i>(The 3 point bucket represents being up a bishop and the 1 point bucket represents being up by a pawn.)</i>"},
      { id: "the_tree", title: "The Middle &amp; White's Bars", text : "The center bar shows the percentage of games that are about even.<br><br>The bars to the right are white's mirroring the black buckets from 1 point through already won games."},
      { id: "the_toolbar", title: "Options", text : "Used to set the rating range and color."},
    ]
  }

  const tourInfo = ref(sliceDiceTourInfo)

  const styleBoard = ref({
    position : "absolute",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px"
  })

  const styleStatusLine = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "text-align" : "center"
  })

  const styleMoveHistory = ref({
    position : "absolute",
    "overflow-y" : "scroll",
    top : "0px",
    left : "100px",
    width: "100px",
    height : "100px",
    "font-size" : MOVEHISTORY_FONTSIZE + "px",
    "text-align" : "left",
    "line-height" : "1.2em",
    // "background-color" : "#8198bc",
    // "color" : "white"
  })

  doStartupCheck(false,afterStartupCallbackRoutine)

  const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

  function afterStartupCallbackRoutine(stuffChanged,errorProgram,errorEntry) {
    //console.log("in after start" ,stuffChanged,errorProgram,errorEntry)
    if (errorProgram != null)
      openErrorModal(errorProgram,errorEntry)
    isSubscriber = (connectionStore.getIsSubscriber == 1)

    if (connectionStore.getIsSubscriber != 1) {
      return
    }
    menuTrigger.value++
    updateWidthHeights()
  }
  
  onMounted(() => {
    updateWidthHeights()
    getRepertoiresNeedingSpacedRepetiion()
  })

  watch(() => windowSizeStore.getWindowSize, () => {
    windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }
    updateWidthHeights()
    menuTrigger.value++
  })

  function formatDate(date,separator) {
    const year = date.toLocaleString('default', {year: 'numeric'});
    const month = date.toLocaleString('default', {
      month: '2-digit',
    });
    const day = date.toLocaleString('default', {day: '2-digit'});

    return [year, month, day].join(separator);
  }

  function updateStyleObjects(boundaries) {
    boardSize.value = boundaries['board'].height

    styleBoard.value.height = boundaries['board'].height + "px"
    styleBoard.value.width = boundaries['board'].width + "px"
    styleBoard.value.top = boundaries['board'].top + "px"
    styleBoard.value.left = boundaries['board'].left + "px"

    styleStatusLine.value.height = boundaries['status'].height + "px"
    styleStatusLine.value.width = boundaries['status'].width + "px"
    styleStatusLine.value.top = boundaries['status'].top + "px"
    styleStatusLine.value.left = boundaries['status'].left + "px"

    styleMoveHistory.value.height = boundaries['history'].height + "px"
    styleMoveHistory.value.width = boundaries['history'].width + "px"
    styleMoveHistory.value.top = boundaries['history'].top + "px"
    styleMoveHistory.value.left = boundaries['history'].left + "px"
  }

  function updateWidthHeights() {

    const availableSpace = availableWidthHeight()
    const isPortrait = isScreenPortraitOrientation(availableSpace)
    const boundaries = (isPortrait) ? calculatePortraitWidthHeights(availableSpace) :
                                      calculateLandscapeWidthHeights(availableSpace)
    
    //console.log("updatewidth in repdrill ",availableSpace,isPortrait)

    updateStyleObjects(boundaries)
  }

  function calculatePortraitWidthHeights(availableSpace) {

    const availableSpaceForBoard = { width : availableSpace.width ,
                  height : availableSpace.height - MOVEHISTORY_HEIGHT * 5 ,
                  isPortrait : true }

    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = boardPositionTop + boardHeight
    const statusPositionLeft = availableSpace.leftRightIndent
    const statusHeight = MOVEHISTORY_HEIGHT * 3
    const statusWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const moveHistoryPositionTop = statusPositionTop + statusHeight
    const moveHistoryPositionLeft = availableSpace.leftRightIndent
    const moveHistoryHeight = availableSpace.height - moveHistoryPositionTop
    const moveHistoryWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    const result = { board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop + availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      },
      history : {
        width : moveHistoryWidth,
        height : moveHistoryHeight,
        left : moveHistoryPositionLeft + availableSpace.leftIndent,
        top : moveHistoryPositionTop+ availableSpace.topIndent
      }
    }
    return (result)
  }

  function calculateLandscapeWidthHeights(availableSpace) {

    const availableSpaceForBoard = { width : availableSpace.width - 150,
                height : availableSpace.height ,
                isPortrait : false }
    const boardDimensions = calculateChessBoardRect(availableSpaceForBoard,1.0)

    const boardHeight = boardDimensions.height
    const boardWidth = boardDimensions.width
    const boardPositionTop = boardDimensions.y
    const boardPositionLeft = boardDimensions.x + availableSpace.leftRightIndent

    const statusPositionTop = 0
    const statusPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const statusHeight = MOVEHISTORY_HEIGHT * 3
    const statusWidth = availableSpace.width - statusPositionLeft

    const moveHistoryPositionTop = statusPositionTop + statusHeight
    const moveHistoryPositionLeft = boardPositionLeft + boardWidth + availableSpace.leftRightIndent
    const moveHistoryHeight = availableSpace.height - moveHistoryPositionTop
    const moveHistoryWidth = availableSpace.width - moveHistoryPositionLeft

    const result = { 
      board : {
        width : boardWidth,
        height : boardHeight,
        left : boardPositionLeft + availableSpace.leftIndent,
        top : boardPositionTop+ availableSpace.topIndent
      },
      status : {
        width : statusWidth,
        height : statusHeight,
        left : statusPositionLeft + availableSpace.leftIndent,
        top : statusPositionTop+ availableSpace.topIndent
      },
      history : {
        width : moveHistoryWidth,
        height : moveHistoryHeight,
        left : moveHistoryPositionLeft + availableSpace.leftIndent,
        top : moveHistoryPositionTop+ availableSpace.topIndent
      }
    }
    return (result)
  }

  // End for Slice & Dice

  function incrementAppendTrigger() {
    if (blankAppendTrigger.length > 64)
      blankAppendTrigger = ""
    blankAppendTrigger += " "
  }

  function tourDone() {
    showTour.value = false
  }

  function toolbarClick(index) {

    const element = findToolbarElement(toolbarElements.value,index)
    if (element.disabled)
      return

    switch (index) {
      case TOOLBAR_NEXT_REP :
        showThumb.value = "none"
        if (repertoireIndex < repertoires.length -1) {
          repertoireIndex++
          getSpacedRepetitionLines(repertoireIndex)
        }
        break
      case TOOLBAR_HINT :
        hintFen.value = [fen.value, availableMoves.value[0].fen]
        lineList[lineIndex].hadErrorThisTry = true
        lineList[lineIndex].hadErrorOnAnyTry = true
        break    
    }
  }

  // https://stackoverflow.com/questions/951021/what-is-the-javascript-version-of-sleep
  // sleep time expects milliseconds
  function promiseSleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  function makePlayerMoveOnlyAvailableMove(fromFenid4,toFenid4) {

    availableMoves.value = []

    const key = fromFenid4 + "," + toFenid4
    const move = moveList.get(key)

    const oneAvailableMove = { 
      from : move.fromSquare, 
      to : move.toSquare,
      san : move.san,
      fen : move.fen,
      fenid4 : move.to,
    }
    availableMoves.value.push(oneAvailableMove)
    return (true)
  }

  function addMoveToHistoryStack(san,fenid4,fromSquare,toSquare) {

    const oneMove = {
            fenid4 : fenid4, 
            san : san, 
            fromSquare : fromSquare,
            toSquare : toSquare
            }

    moveHistoryStack.value.push(oneMove)
    moveHistoryTrigger.value++

    return (oneMove)
  }

  function addOpponentMoveToHistoryStack(opponentMove) {
    //console.log("opponent Move",opponentMove)

    addMoveToHistoryStack(opponentMove.san,opponentMove.to,
                  opponentMove.fromSquare,opponentMove.toSquare)

    const currentFen = fen.value
    const newFen = opponentMove.fen

    // wait a bit before animating oppponent move
    promiseSleep(250).then(() => {
      // Do something after the sleep!
      animateFen.value = [currentFen, newFen]
      promiseSleep(250).then(() => {
        //console.log("add opponent move to history stack",newFen)
        fen.value = newFen
      });
    });
  
  }

  function displayOpponentMove(fromFenid4,toFenid4) {

    const key = fromFenid4 + "," + toFenid4
    const move = moveList.get(key)
    if (move == null) {
        return
    }

    addOpponentMoveToHistoryStack(move)

    withinLineIndex++
    if (withinLineIndex < lineList[lineIndex].combined.length-1) {
      makePlayerMoveOnlyAvailableMove(lineList[lineIndex].combined[withinLineIndex],
                        lineList[lineIndex].combined[withinLineIndex+1])
    }
    else
      gotoNextLine()
  }

  // is the from/to combination even possible?
  function isMoveValid(requiredFrom,to) {
    //console.log("FEN",fen)
    var fenPieces = fen.value.split(" ")
    fenPieces[5] = 1
    const fenFixed = fenPieces.join(" ")
    chess.load(fenFixed)
    const moves = chess.moves({ verbose: true })
    const possibleMoves = buildAvailableMoves(moves,false)
    //console.log("FROM TO",requiredFrom,to)
    //console.log("possible moves",possibleMoves)

    var rightPieceWrongSquare = false
    for (var i=0; i < possibleMoves.length; i++)
      if (possibleMoves[i].from == requiredFrom && possibleMoves[i].to == to)
        return (true)
    return (false)
  }

  function boardMove(arrayIndex,fromUCI,toUCI,fromNumber,toNumber) {

    //console.log("board move",arrayIndex,fromUCI,toUCI,fromNumber,toNumber)

    // player made a bad move -- either from or to
    if (arrayIndex < 0) {
      if (lineIndex < 0 || repertoireIndex >= repertoires.length)
        return

      // if correct piece moves to invalid square then don't generate error. assume "fat fingers"
      // don't show any error
      if (arrayIndex == -2 && !isMoveValid(fromNumber,toNumber)) {
        //console.log("*** MOVE NOT VALID for correct piece")
        squareColorArray.value = []

        // promiseSleep(1000).then(() => {
        //   squareColorArray.value = []
        // }); 
        return
      }

      lineList[lineIndex].hadErrorThisTry = true
      lineList[lineIndex].hadErrorOnAnyTry = true
      return
    }

    fen.value = availableMoves.value[arrayIndex].fen
    //console.log("board move",fen.value)
    
    const fenid4 = availableMoves.value[arrayIndex].fenid4
    const san = availableMoves.value[arrayIndex].san
    const fromSquare = availableMoves.value[arrayIndex].from
    const toSquare = availableMoves.value[arrayIndex].to

    addMoveToHistoryStack(san,fenid4,fromSquare,toSquare)

    withinLineIndex++

    //console.log("withinLineIndex",withinLineIndex,lineIndex,lineList[lineIndex].combined.length)
    if (withinLineIndex < lineList[lineIndex].combined.length-2) {
      displayOpponentMove(lineList[lineIndex].combined[withinLineIndex],
                lineList[lineIndex].combined[withinLineIndex+1])
    }
    else {
      squareColorArray.value = [ { square : toUCI , color : "lightgreen" /* "#5EBC5E"*/}]

      promiseSleep(500).then(() => {
        squareColorArray.value = []
        gotoNextLine()
      }); 
    }
    //getAvailableMoves(fenid4,previousMovePercentage,"update_repertoire")
  }

  function debounce(callback, interval=500) {
    let debounceTimeoutId;

    return function(...args) {
      clearTimeout(debounceTimeoutId);
      debounceTimeoutId = setTimeout(() => callback.apply(this, args), interval);
    };
  }
 
  function showConfetti(doAllDone) {
    var element = document.getElementById("app")

    party.resolvableShapes["whiteKing"] = "<img src='img/chesspieces/wikipedia/wK.svg'/>"
    party.resolvableShapes["whiteQueen"] = "<img src='img/chesspieces/wikipedia/wQ.svg'/>"
    party.resolvableShapes["blackKing"] = "<img src='img/chesspieces/wikipedia/bK.svg'/>"
    party.resolvableShapes["blackQueen"] = "<img src='img/chesspieces/wikipedia/bQ.svg'/>"

    if (doAllDone) {
      party.sparkles(element, {
        count: party.variation.range(100, 200),
        speed: party.variation.range(5, 20),
        shapes: ["whiteKing","whiteQueen","blackKing","blackQueen"]
      });  
    }
    else {
      party.sparkles(element, {
        count: party.variation.range(100, 200),
        speed: party.variation.range(5, 20),
      });
    }
  }

  function gotoNextLine() {

    //console.log("going to next line",lineIndex)
    // if had a clean run then done.  Update server
    if (lineIndex >= 0) {
      //console.log("had error ",lineList[lineIndex].hadErrorThisTry)
      if (lineList[lineIndex].hadErrorThisTry == false) {
        setUpdateBoxAndDate(lineIndex,lineList[lineIndex].hadErrorOnAnyTry )
        lineList[lineIndex].done = true
      }
      else
        lineList[lineIndex].hadErrorThisTry = false
    }

    // count lines to learn for status
    var linesToLearn = 0
    for (var i=0; i < lineList.length; i++)
      if (lineList[i].done == false)
        linesToLearn++

    if (linesToLearn == 0) {
      if (repertoireIndex < repertoires.length -1) {
        showConfetti(false)
        showThumb.value = "done"
        statusLineString.value = t("All Done with Repertoire. Tap 'Next-Rep'")
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT_REP, false)
      }
      else {
        showConfetti(true)
        showThumb.value = "alldone"
        statusLineString.value = t("All Done for the Day") + "!"
        setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT_REP, true)
      }
      setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT, true)
      toolbarTrigger.value++
    }
    else
    if (linesToLearn == 1)
      statusLineString.value = t("Just one more path") + "!!"
    else
      statusLineString.value = linesToLearn + " " + t("paths to learn")

    const currentLineIndex = lineIndex

    // find next line that is still active.
    for (lineIndex = currentLineIndex + 1; lineIndex < lineList.length; lineIndex++)
      if (lineList[lineIndex].done == false)
        break
    
    // if we didn't find an active line going forward loop back to begin and see there is one to redo
    if (lineIndex == lineList.length) {
      for (lineIndex = 0; lineIndex <= currentLineIndex; lineIndex++)
        if (lineList[lineIndex].done == false)
          break

      // all done
      if (lineIndex > currentLineIndex)
        return (false)
    }

    //console.log("NEXT LINE  START INITIAL FEN",lineIndex,INITIAL_FEN)
    fen.value = INITIAL_FEN
    moveHistoryStack.value = []
    withinLineIndex = 0

    // find first move
    const firstFromFenid4 = lineList[lineIndex].combined[withinLineIndex]
    const firstToFenid4 = lineList[lineIndex].combined[withinLineIndex+1]
    const firstMoveKey = firstFromFenid4 + "," + firstToFenid4
    const firstMove = moveList.get(firstMoveKey)
      
    if (playingWhite == 1) {
      statusLineString.value += " -- " + t("play") + ": 1." + firstMove.san
      makePlayerMoveOnlyAvailableMove(firstFromFenid4,firstToFenid4)
      
      // draw arrow for a second so player knows what to do

      const pairNumber = parseInt(firstMove.fromSquare) * 100 + parseInt(firstMove.toSquare)
      const pairString = squarePairToAlgebraic(pairNumber)
      arrowPairs.value = []
      promiseSleep(250).then(() => {
        arrowPairs.value = []
        arrowPairs.value.push(pairString)
        hintFen.value = [fen.value, availableMoves.value[0].fen]
        //console.log("draw arrow",hintFen.value)
        promiseSleep(750).then(() => {
          arrowPairs.value = []
        });   
      });
    }
    else {
      displayOpponentMove(lineList[lineIndex].combined[withinLineIndex],
                lineList[lineIndex].combined[withinLineIndex+1])
    }
  }

  function processSpacedRepetitionJsonResponse (json) {
    //console.log(" in coverage json callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const froms = json['froms'].split(",")
    const tos = json['tos'].split(",")
    const board_froms = json['board_froms'].split(",")
    const board_tos = json['board_tos'].split(",")
    const sans = json['sans'].split(",")
    const fens = json['fens'].split(",")

    const lineCount = Number(json['line_count'])
    const lines = json['lines'].split("\t")
    const boxes = json['boxes'].split(",")

    lineIndex = -1
    withinLineIndex = 0

    lineList = []
    for (var i=0; i < lineCount; i++) {
      const oneLine = {
        box : boxes[i],
        done : false,
        hadErrorThisTry : false,
        hadErrorOnAnyTry : false,
        combinedString : lines[i],
        combined : lines[i].split(",")
      }
      lineList.push(oneLine)
    }

    const moveCount = Number(json['move_count'])

    moveList.clear();

    for (var i=0; i < moveCount; i++) {
      const oneMove = { 
                from : froms[i], 
                to : tos[i], 
                fromSquare : board_froms[i],
                toSquare : board_tos[i],
                promotion : 0,
                san : sans[i], 
                fen : fens[i],
              }
  
      const key = froms[i] + "," + tos[i]
      moveList.set(key,oneMove)

      //if (playingWhite == 0)
      //  displayOpponentMove(initialFenid4)
    }

    gotoNextLine()
    
  }

  function getSpacedRepetitionLines(index) {

    moveHistoryStack.value = []
    moveHistoryTrigger.value++
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_HINT, false)
    setToolbarElementDisabledFlag(toolbarElements.value,TOOLBAR_NEXT_REP, true)
    toolbarTrigger.value++

    repertoireId = repertoires[index].id
    playingWhite = repertoires[index].playWhite
    orientation.value = (repertoires[index].playWhite == 1) ? "white" : "black"
    repertoireDescription.value = repertoires[index].name + ", " + t("Rating") + ":" + repertoires[index].ratingMin 
                  + "-" + repertoires[index].ratingMax + " " + t("with") + " " + repertoires[index].percentage + "% " + t("Filter")

    var formData = {
      repid : repertoireId,
      today : todayDate
    }

    //console.log("get spaced postdata ",formData)
    useGetData("chessvis_opening_get_spaced_repetition.php", formData, processSpacedRepetitionJsonResponse)
    
  }

  function processRepertoireListJsonResponse(json) {    
    //console.log(" in repertoire drill list json callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }

    const count = json['count']
    const ids = json['ids'].split("\t")
    const names = json['names'].split("\t")
    const playWhites = json['play_whites'].split("\t")
    const ratingMins = json['mins'].split("\t")
    const ratingMaxs = json['maxs'].split("\t")
    const percents = json['percents'].split("\t")
    const drillCounts = json['drill_counts'].split("\t")

    repertoires = []
    repertoireIndex = 0

    for (var i=0; i < count; i++) {
      const oneRep = {
              index : i,
              id : ids[i],
              name : names[i],
              playWhite : playWhites[i],
              ratingMin : ratingMins[i],
              ratingMax : ratingMaxs[i],
              percentage : percents[i],
              drillCount : drillCounts[i]
      }
      repertoires.push(oneRep)
    }

    if (count == 0) {
      repertoireDescription.value = t("No Repertoires need spaced repetition today")
    }
    else {
      getSpacedRepetitionLines(repertoireIndex)
    }
    menuTrigger.value++
  }

  function getRepertoiresNeedingSpacedRepetiion() {

    var formData = {
      today : todayDate
    }

    useGetData("chessvis_opening_build_spaced_repetition.php", formData, processRepertoireListJsonResponse)
  }

  function processUpdateJsonResponse(json) {
    //console.log(" in update json callback",json)
    if (json.hasOwnProperty('error')) {
      openErrorModal(json['programRun'],json['error'])
      return;
    }
  }

  function setUpdateBoxAndDate(index,hadError) {

    const currentBox = lineList[index].box
    const hadErrorString = (hadError) ? "1" : "0"
    const combinedString = lineList[index].combinedString

    var formData = {
      repid : repertoireId,
      combined : combinedString,
      box : currentBox,
      wrong : hadErrorString,
      today : todayDate
    }

    //console.log("update spaced repetition postdata ",formData)
    useGetData("chessvis_opening_set_update_spaced_repetition.php", formData, processUpdateJsonResponse)
    
  }

</script>

<style scoped>

/* ion-content {
    --background: lightgray;
    --color: #fff;
    --overflow: hidden;
  } */

ion-button[slot='fixed'] {
    top: 0%;
    left : 0%;
    height : 5%;
    width : 100%;
  }

.blue {
  position :absolute;
  background-color: blue;
  top : 0px;
  left : 0px;
  height : 100px;
  width : 200px;
  z-index : -1;
}

.green {
  position :absolute;
  background-color: green;
  top : 200px;
  left : 50px;
  height : 100px;
  width : 200px;
}

</style>
